<div class="skeleton-stack" [style.gap]="gap" [style.minHeight]="resolvedMinHeight" [style.height]="height"
  aria-live="polite" aria-busy="true">
  @for (row of skeletonRows; track row) {
    <div
      class="skeleton-item"
      [class.skeleton-item--animate]="animate"
      [class.skeleton-item--circle]="circle"
      [style.width]="circle ? height : getLineWidth(row)"
      [style.height]="height"
      [style.borderRadius]="circle ? '50%' : borderRadius">
    </div>
  }
</div>
